// images
import blogImg1 from "../images/blog/blog-1/1.jpg";
import blogImg2 from "../images/blog/blog-1/2.jpg";
import blogImg3 from "../images/blog/blog-1/3.jpg";
import blogImg4 from "../images/blog/blog-4/1.jpg";
import blogImg5 from "../images/blog/blog-4/2.jpg";
import blogImg6 from "../images/blog/blog-4/3.jpg";
import blogImg7 from "../images/blog/blog-12/1.jpg";
import blogImg8 from "../images/blog/blog-12/2.jpg";
import blogImg9 from "../images/blog/blog-12/3.jpg";
import blogImg10 from "../images/blog/blog-12/4.jpg";
import blogImg11 from "../images/blog/blog-12/1.jpg";


import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";
import blogSingleImg4 from "../images/blog-details/4.jpg";
import blogSingleImg5 from "../images/blog-details/5.jpg";
import blogSingleImg6 from "../images/blog-details/6.jpg";
import blogSingleImg7 from "../images/blog-details/7.jpg";
import blogSingleImg8 from "../images/blog-details/8.jpg";
import blogSingleImg9 from "../images/blog-details/9.jpg";
import blogSingleImg10 from "../images/blog-details/10.jpg";
import blogSingleImg11 from "../images/blog-details/11.jpg";




const blogs = [
    {
        id: '1',
        title: 'Personalized Interiors, Endless Possibilities.',
        title2: 'Personalized Interiors, Endless Possibilities.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food1',
        screens: blogImg1,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Bringing Style to Life, One Room at a Time.',
        title2: 'Bringing Style to Life, One Room at a Time.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food2',
        screens: blogImg2,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'Designing Spaces Youll Love Coming Home To.',
        title2: 'Designing Spaces Youll Love Coming Home To.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food3',
        screens: blogImg3,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '4',
        title: 'Interior Design For Your Peace And Happiness.',
        title2: 'Interior Design For Your Peace And Happiness.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food4',
        screens: blogImg4,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg4,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '5',
        title: 'Interior Design For Your Peace And Happiness.',
        title2: 'Interior Design For Your Peace And Happiness.',
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food5',
        screens: blogImg5,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg5,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '6',
        title: 'Interior Design For Your Peace And Happiness.',
        title2: 'Interior Design For Your Peace And Happiness.', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food6',
        screens: blogImg6,
        link: 'READ MORE',
        description: 'Lorem sum has been the industry standard dummy of the text ever since the scrambled it to make.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg6,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '7',
        title: 'Best Construction Idea For Your Next Projects',
        title2: 'Best Construction Idea For Your Next Projects', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food7',
        screens: blogImg7,
        link: 'READ MORE',
        description: 'Nunc sed ut purus pellentesque in lacus integer sagittis sed. Eget duis est  sodales eu.Commodo faucibus urna felis vitae.Interdum pellentesque suspendisse siteget.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg7,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '8',
        title: 'Building the Architecture of Future cities',
        title2: 'Building the Architecture of Future cities', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food8',
        screens: blogImg8,
        link: 'READ MORE',
        description: 'Nunc sed ut purus pellentesque in lacus integer sagittis sed. Eget duis est  sodales eu.Commodo faucibus urna felis vitae.Interdum pellentesque suspendisse siteget.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg8,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '9',
        title: 'Brooklyn Great Penthouse Agreement and Deal',
        title2: 'Brooklyn Great Penthouse Agreement and Deal', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food8',
        screens: blogImg9,
        link: 'READ MORE',
        description: 'Nunc sed ut purus pellentesque in lacus integer sagittis sed. Eget duis est  sodales eu.Commodo faucibus urna felis vitae.Interdum pellentesque suspendisse siteget.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg9,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '10',
        title: 'Best Construction Idea For Your Next Projects',
        title2: 'Best Construction Idea For Your Next Projects', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food10',
        screens: blogImg10,
        link: 'READ MORE',
        description: 'Nunc sed ut purus pellentesque in lacus integer sagittis sed. Eget duis est sodales eu.Commodo faucibus urna felis vitae.Interdum pellentesque suspendisse siteget.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg10,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '11',
        title: 'Building the Architecture of Future cities',
        title2: 'Building the Architecture of Future cities', 
        subtitle: 'ARCHITECTURE / BY: Dos',
        slug: 'How-To-Teach-Kids-Ramadan-Isn’t-About-Food11',
        screens: blogImg11,
        link: 'READ MORE',
        description: 'Nunc sed ut purus pellentesque in lacus integer sagittis sed. Eget duis est sodales eu.Commodo faucibus urna felis vitae.Interdum pellentesque suspendisse siteget.',
        author: 'Loura Sweety',
        create_at: '25 Sep 2025',
        blogSingleImg: blogSingleImg11,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },



];
export default blogs;



